import { render, staticRenderFns } from "./CurrencyBadge.vue?vue&type=template&id=fec981c0&scoped=true&"
import script from "./CurrencyBadge.vue?vue&type=script&lang=js&"
export * from "./CurrencyBadge.vue?vue&type=script&lang=js&"
import style0 from "./CurrencyBadge.vue?vue&type=style&index=0&id=fec981c0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fec981c0",
  null
  
)

export default component.exports